export class ConditionalMandatory {
    constructor(conditionalMandatoryId: number, conditionalMandatoryIdentity: number, eventTypeGroupId: number) {
        this.conditionalMandatoryId = conditionalMandatoryId;
        this.conditionalMandatoryIdentity = conditionalMandatoryIdentity;
        this.eventTypeGroupId = eventTypeGroupId;
    }
    conditionalMandatoryId: number;
    conditionalMandatoryIdentity: number;
    eventTypeGroupId: number;
}
